/**
 * Figma 1440 reference proportions — use as ratios / clamps, not as
 * fixed layout that ignores the viewport.
 *
 * Artboard: 58:39161 (1440×3061)
 */
export const FIGMA_REF = {
  artboard: 1440,
  hero: {
    width: 1380,
    /** Figma frame is 1380×664 (≈0.481), but we render a shorter hero. */
    height: 664,
    heightToWidth: 0.5,
    /** inset from artboard edge → ~2% */
    insetRatio: 30 / 1440,
    radius: 20,
    text: {
      /** left padding inside hero → ~9.5% of hero width */
      leftRatio: 132 / 1380,
      /** top padding inside hero → ~13% of hero height */
      topRatio: 89 / 664,
      maxWidth: 789,
    },
  },
  search: {
    width: 1060,
    height: 108,
    radius: 8,
    /** how far the bar hangs over the hero bottom */
    overlap: 48,
  },
  nav: {
    height: 108,
    padInline: 64,
  },
} as const;
